import { ProjectBuilder } from 'modules/Project/views/ProjectBuilder/ProjectBuilder';

export default ProjectBuilder;
